import Pages from './Pages';
import cms from './cms'
export default {
  Pages: Pages,
  cms:cms
};
